import { MODEL_VERSION, NewbieTaskName } from '@/app/constants';
import type { FormTabType, ModelVersion } from '@/app/types';

/**
 * 新手任务导航配置
 * 定义每个新手任务对应的跳转路径、任务类型和模型版本
 */
interface NewbieTaskNavigationConfig {
  /** 目标页面路径 */
  targetPage: string;
  /** 任务类型（排除 scene） */
  taskType?: Exclude<FormTabType, 'scene'>;
  /** 目标模型版本 */
  targetModelVersion?: ModelVersion;
}

/**
 * 新手任务导航配置映射表
 * 集中管理所有 NewbieTaskName 到导航配置的映射关系
 */
const NEWBIE_TASK_NAVIGATION_CONFIG_MAP: Record<NewbieTaskName, NewbieTaskNavigationConfig> = {
  [NewbieTaskName.newbie_task_i2v_v2_credit]: {
    targetPage: '/create/img2video',
    taskType: 'img2video',
    targetModelVersion: MODEL_VERSION['2.0'],
  },
  [NewbieTaskName.newbie_task_i2v_Q1_credit]: {
    targetPage: '/create/img2video',
    taskType: 'img2video',
    targetModelVersion: MODEL_VERSION.Q1,
  },
  [NewbieTaskName.newbie_task_c2v_Q1_credit]: {
    targetPage: '/create/character2video',
    taskType: 'character2video',
    targetModelVersion: MODEL_VERSION.Q1,
  },
  [NewbieTaskName.newbie_task_template_credit]: {
    targetPage: '/templates',
  },
  [NewbieTaskName.newbie_task_i2v_Q2_credit]: {
    targetPage: '/create/img2video',
    taskType: 'img2video',
    targetModelVersion: MODEL_VERSION.Q2,
  },
  [NewbieTaskName.newbie_task_c2v_Q2_credit]: {
    targetPage: '/create/character2video',
    taskType: 'character2video',
    targetModelVersion: MODEL_VERSION.Q2,
  },
  [NewbieTaskName.newbie_task_use_material_credit]: {
    targetPage: '/create/character2video',
    taskType: 'character2video',
    targetModelVersion: MODEL_VERSION.Q2,
  },
  [NewbieTaskName.newbie_task_material_create_credit]: {
    targetPage: '/assets/myreferences',
  },
};

/**
 * 获取新手任务的导航配置
 * @param newbieTaskName - 新手任务名称
 * @returns 导航配置对象，包含目标页面、任务类型和模型版本
 */
export function getNewbieTaskNavigationConfig(newbieTaskName: NewbieTaskName): NewbieTaskNavigationConfig {
  return (
    NEWBIE_TASK_NAVIGATION_CONFIG_MAP[newbieTaskName] ?? {
      targetPage: '/',
    }
  );
}
